export default __webpack_public_path__ + "static/media/redVelvet.d340030e.png";